import { CornerDownLeft, Search, X } from "lucide-react";
import { useEffect, useState } from "react";
import { Input } from "../ui/input";

export function ObjectListSearch2({ onSearchChange, initialValue = "" }: { onSearchChange: (value: string) => void; initialValue?: string }) {
    const [value, setValue] = useState<string>(initialValue);
    const [lastSearchedValue, setLastSearchedValue] = useState<string>(initialValue);

    useEffect(() => {
        setValue(initialValue);
        setLastSearchedValue(initialValue);
    }, [initialValue]);

    const performSearch = () => {
        setLastSearchedValue(value);
        onSearchChange(value);
    };

    const clearSearch = () => {
        setValue("");
        setLastSearchedValue("");
        onSearchChange("");
    };

    const hasValueChanged = value !== lastSearchedValue;
    const shouldShowCornerDownLeft = value && hasValueChanged;

    return (
        <div className="md:w-[200px] lg:w-[250px]">
            <div className="group relative ml-auto">
                <Search className="absolute left-2.5 top-2.5 h-4 w-4 text-gray-500" />
                <Input
                    type="text"
                    placeholder="Search..."
                    className="w-full rounded bg-background shadow-sm"
                    value={value}
                    onChange={e => setValue(e.target.value)}
                    onKeyDownCapture={e => {
                        if (e.key === "Enter") performSearch();
                    }}
                    icon={value ? (shouldShowCornerDownLeft ? CornerDownLeft : X) : undefined}
                    onIconClick={() => {
                        if (shouldShowCornerDownLeft) {
                            performSearch();
                        } else {
                            clearSearch();
                        }
                    }}
                />
                <div className="absolute bottom-full left-1/2 z-10 mb-2 flex max-w-full -translate-x-1/2 items-center whitespace-nowrap rounded  bg-white px-2 py-1 text-xs font-medium text-black opacity-0 shadow-lg group-hover:opacity-100">
                    <div className="absolute left-1/2 top-full h-0 w-0 -translate-x-1/2 border-l-4 border-r-4 border-t-4 border-l-transparent border-r-transparent border-t-white"></div>
                    Search on visible columns only
                </div>
            </div>
        </div>
    );
}
